"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ClassOptionsOverlayControlModule = /** @class */ (function () {
    function ClassOptionsOverlayControlModule() {
    }
    return ClassOptionsOverlayControlModule;
}());
exports.ClassOptionsOverlayControlModule = ClassOptionsOverlayControlModule;
